/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface InferencerTestOk
 */
export interface InferencerTestOk {
  /**
   *
   * @type {boolean}
   * @memberof InferencerTestOk
   */
  success: boolean;
}

/**
 * Check if a given object implements the InferencerTestOk interface.
 */
export function instanceOfInferencerTestOk(value: object): value is InferencerTestOk {
  if (!('success' in value) || value['success'] === undefined) return false;
  return true;
}

export function InferencerTestOkFromJSON(json: any): InferencerTestOk {
  return InferencerTestOkFromJSONTyped(json, false);
}

export function InferencerTestOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): InferencerTestOk {
  if (json == null) {
    return json;
  }
  return {
    success: json['success'],
  };
}

export function InferencerTestOkToJSON(value?: InferencerTestOk | null): any {
  if (value == null) {
    return value;
  }
  return {
    success: value['success'],
  };
}
